export default "<div id=\"{{fullId}}\" style=\"height: 100%;\"></div>\n";